// extracted by mini-css-extract-plugin
export default {"container":"CloneTag_container__ODazC"};